import React from 'react'
import styles from '../Hero.css'
import PropTypes from "prop-types"
import {SubBrand} from "../../../constants/consts-types"
import SubBrandLogo from "../../SubBrandLogo/SubBrandLogo"

const CategoryOrSubBrand = React.forwardRef((props, ref) => {
  const {category, subBrand, url} = props

  return (
    <div
      ref={ref}
      className={styles.category}
    >
      {subBrand !== SubBrand.SMK && subBrand !== SubBrand.SMK2 ?
        <SubBrandLogo subBrand={subBrand} url={url}/>
        :
        category
      }
    </div>
  )
})

CategoryOrSubBrand.propTypes = {
  category: PropTypes.string,
  subBrand: PropTypes.string
}

export default CategoryOrSubBrand



// WEBPACK FOOTER //
// ./src/components/Hero/partials/CategoryOrSubBrand.js